import React from 'react'
import InfoFieldGroup from '../../../utils/InfoField/InfoFieldGroup'
import Header from './header'
import ButtonSwitch from './buttonSwitch'

export default function RepresentantesPrivilegios({ user, permissions, setPermissions }) {
  return (
    <>

      <Header header={'Representantes'} />
      <InfoFieldGroup
        fields={
          [
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'VerRepresentantes'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Ver Representantes'}
                  descricao={''}
                />
              , editable: false,
            },
            {
              // label: '',
              value:
                <ButtonSwitch
                  // width={true}
                  adminId={user._id}
                  permission={'CadastrarRepresentantes'}
                  permissions={permissions}
                  setPermission={setPermissions}
                  title={'Cadastrar Representantes'}
                  descricao={''}
                />
              , editable: false,
            },
          ]} />

    </>
  )
}
